export { default } from './AuthTitle';



// WEBPACK FOOTER //
// src/components/login/AuthTitle/index.js